import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BikeService } from '../../../services/bike.service';
import { LookupService } from '../../../services/lookup.service';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../services/helpers.service';
import moment from 'moment';

@Component({
  selector: 'app-component-edit',
  templateUrl: './component-edit.component.html',
  styleUrls: ['./component-edit.component.scss'],
  providers: [MessageService],
})
export class ComponentEditComponent implements OnInit {
  @Input() gear;
  @Input() distanceMetric;
  @Input() closeModal = true;

  @Output() componentCreated = new EventEmitter<any>();

  public ComponentForm: FormGroup;
  public gearTypes: any = [];
  public gearTypeOptions: any = [];
  public units: any = [];
  public selectedUnit: string = '';
  public countryData: any = {};
  public saving: boolean = false;
  constructor(
    public messageService: MessageService,
    private bikeService: BikeService,
    private lookupService: LookupService,
    public modal: NgbActiveModal,
    private fb: FormBuilder,
    private translate: TranslateService,
    private helpersService: HelpersService,
  ) { }

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.setupValidation();
    this.getGearTypes();
    this.setUnit();
    this.units = [
      {
        label: this.translate.instant(
          'bikeshop.modal.component.select_a_service_interval_unit',
        ),
        value: 0,
      },
      { label: this.distanceMetric, value: 'km' },
      { label: this.translate.instant('general.hours'), value: 'hours' },
      { label: this.translate.instant('general.months'), value: 'months' },
    ];
  }

  getGearTypes() {
    this.lookupService.getGearTypes().subscribe((gearTypes) => {
      this.gearTypes = gearTypes;
      this.gearTypeOptions = gearTypes.map((item) => {
        return { label: item.Description, value: item.Description };
      });
      //this.gearTypeOptions.push({
      //  label: this.translate.instant(
      //    'bikeshop.modal.component.select_a_gear_type',
      //  ),
      //  value: 0,
      //});
    });
  }

  setupValidation() {
    this.ComponentForm = this.fb.group({
      Manufacturer: new FormControl(
        this.gear.manufacturer,
        Validators.required,
      ),
      Model: new FormControl(this.gear.model, Validators.required),
      Description: new FormControl(this.gear.note, Validators.required),
      TypeID: new FormControl(this.gear.type, [Validators.required]),
      KmServiceInterval: new FormControl(
        this.gear.serviceTimeframe === 'km' && this.gear.serviceInterval,
        [Validators.required, Validators.min(1)],
      ),
      MinutesServiceInterval: new FormControl(
        this.gear.serviceTimeframe === 'hours' && this.gear.serviceInterval,
        [Validators.required, Validators.min(1)],
      ), //Convert to Hours
      MonthsServiceInterval: new FormControl(
        this.gear.serviceTimeframe === 'months' && this.gear.serviceInterval,
        [Validators.required, Validators.min(1)],
      ),
      DateAdded: new FormControl(
        this.gear.dateAdded ? new Date(this.gear.dateAdded) : new Date(),
        Validators.required,
      ),
      LastService: new FormControl(
        this.gear.lastService ? new Date(this.gear.lastService) : new Date(),
        Validators.required,
      ),
      //'SKU': new FormControl(this.gear.SKU, [Validators.nullValidator])
    });
  }

  setUnit() {
    /*if(this.gear.KmServiceInterval>0){
          this.selectedUnit = 1;
        }else if(this.gear.MinutesServiceInterval>0){
          this.selectedUnit = 2;
        }else if(this.gear.MonthsServiceInterval>0){
          this.selectedUnit = 3;
        }*/
    this.selectedUnit = this.gear.serviceTimeframe;
    this.setIntervalControls();
  }

  setIntervalControls() {
    if (this.selectedUnit === 'km') {
      this.ComponentForm.controls['KmServiceInterval'].enable();
      this.ComponentForm.controls['MinutesServiceInterval'].disable();
      this.ComponentForm.controls['MonthsServiceInterval'].disable();
    } else if (this.selectedUnit === 'hours') {
      this.ComponentForm.controls['KmServiceInterval'].disable();
      this.ComponentForm.controls['MinutesServiceInterval'].enable();
      this.ComponentForm.controls['MonthsServiceInterval'].disable();
    } else if (this.selectedUnit === 'months') {
      this.ComponentForm.controls['KmServiceInterval'].disable();
      this.ComponentForm.controls['MinutesServiceInterval'].disable();
      this.ComponentForm.controls['MonthsServiceInterval'].enable();
    } else {
      this.ComponentForm.controls['KmServiceInterval'].disable();
      //this.ComponentForm.controls['KmServiceInterval'].setValue(100);
      this.ComponentForm.controls['MinutesServiceInterval'].disable();
      this.ComponentForm.controls['MonthsServiceInterval'].disable();
    }
  }

  checkIfValid() {
    if (this.selectedUnit === 'km') {
      return this.ComponentForm.valid && this.ComponentForm.value.KmServiceInterval > 0;
    } else if (this.selectedUnit === 'hours') {
      return this.ComponentForm.valid && this.ComponentForm.value.MinutesServiceInterval > 0;
    } else if (this.selectedUnit === 'months') {
      return this.ComponentForm.valid && this.ComponentForm.value.MonthsServiceInterval > 0;
    }
    if (this.selectedUnit === undefined) {
      return true;
    }
    if (this.selectedUnit)
      if (this.selectedUnit.trim() === '') {
        return true;
      }
    if (!this.selectedUnit) return true;

    return false;
  }

  saveComponent() {
    let gear = {};
    this.saving = true;
    if (this.gear.id > 0) {
      gear = {
        ID: this.gear.id,
        Type: this.ComponentForm.value.TypeID,
        Brand: this.ComponentForm.value.Manufacturer.trim(),
        Model: this.ComponentForm.value.Model.trim(),
        Note: this.ComponentForm.value.Description.trim(),
        ServiceInterval:
          this.selectedUnit === 'km'
            ? this.ComponentForm.value.KmServiceInterval
            : this.selectedUnit === 'hours'
              ? this.ComponentForm.value.MinutesServiceInterval
              : this.selectedUnit === 'months'
                ? this.ComponentForm.value.MonthsServiceInterval
                : 0,
        ServiceIntervalType: this.selectedUnit,
        DateAdded: moment(this.ComponentForm.value.DateAdded).format(
          'YYYY-MM-DD',
        ),
        DateServiced: moment(this.ComponentForm.value.LastService).format(
          'YYYY-MM-DD',
        ),
      };
    } else {
      gear = {
        BikeID: this.gear.BikeID,
        Components: [
          {
            Type: this.ComponentForm.value.TypeID,
            Brand: this.ComponentForm.value.Manufacturer,
            Model: this.ComponentForm.value.Model,
            Note: this.ComponentForm.value.Description,
            Default: false,
            ServiceInterval:
              this.selectedUnit === 'km'
                ? this.ComponentForm.value.KmServiceInterval
                : this.selectedUnit === 'hours'
                  ? this.ComponentForm.value.MinutesServiceInterval
                  : this.selectedUnit === 'months'
                    ? this.ComponentForm.value.MonthsServiceInterval
                    : 0,
            ServiceIntervalType: this.selectedUnit,
            DateAdded: moment(this.ComponentForm.value.DateAdded).format(
              'YYYY-MM-DD',
            ),
          },
        ],
      };
    }

    this.bikeService.saveGear(gear).subscribe((updatedGear) => {
      console.log(updatedGear);
      this.saving = false;
      if (this.closeModal)
        this.modal.close({ updated: true });
      this.componentCreated.emit(true);
    });
  }

  retireComponent() {
    this.bikeService.retireGear(this.gear.id).subscribe((result) => {
      if (this.closeModal)
        this.modal.close({ updated: true });
      this.componentCreated.emit(true);
    });

  }

  moveAddedCalendar() {
    const panel = document.querySelector('.p-datepicker');
    if (panel) {
      (panel as HTMLElement).style.left =
        `${parseInt((panel as HTMLElement).style.left, 10) + 220}px`;
      (panel as HTMLElement).style.top =
        `${parseInt((panel as HTMLElement).style.top, 10) + 170}px`;
    }
  }

  moveLastServiceCalendar() {
    const panel = document.querySelector('.p-datepicker');
    if (panel) {
      (panel as HTMLElement).style.left =
        `${parseInt((panel as HTMLElement).style.left, 10) - 290}px`;
      (panel as HTMLElement).style.top =
        `${parseInt((panel as HTMLElement).style.top, 10) + 180}px`;
    }
  }
}
